import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserrightsService } from './userrights.service';
import { HttpErrorResponse } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-userrights',
  templateUrl: './userrights.component.html',
  styleUrls: ['./userrights.component.css']
})
export class UserrightsComponent implements OnInit {

  responseData: any;
  users: any;
  UserRightsList: any;
  btnsubmittext = "Show";

  constructor(private service: UserrightsService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    this.fillUser();
  }

  fillUser() {
    this.spinner.show();
    const data = {
    }
    this.service.fillUser(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
        } else {
          this.users = this.responseData.dropdownlist;
        }
      });
  }

  getUserRightsList() {
    var userID = $("#UserID").val();
    if (userID > 0) {
      this.spinner.show();
      const data = {
        UserID: userID
      }
      this.service.getUserRightsList(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          } else {
            this.UserRightsList = this.responseData.UserRights;
          }
        });
    } else {
      this.toastr.error("Select user");
    }
  }

  setUserRights() {
    for (var i = 0; i < this.UserRightsList.length; i++) {
      this.UserRightsList[i]["allow"] = $("#allow" + i).prop("checked") ? 1 : 0
      this.UserRightsList[i]["Add"] = $("#isAdd" + i).prop("checked") ? 1 : 0
      this.UserRightsList[i]["Edit"] = $("#isEdit" + i).prop("checked") ? 1 : 0
      this.UserRightsList[i]["Del"] = $("#isDelete" + i).prop("checked") ? 1 : 0
    }
    const data = {
      UserRights: this.UserRightsList,
      UserID: $("#UserID").val(),
    };

    this.spinner.show();
    this.service.SetUserRightsDetail(data).subscribe(data => {
      this.spinner.hide();
      this.responseData = data;
      if (this.responseData.status == false) {
        this.toastr.error(this.responseData.message);
      }else{
        this.toastr.success(this.responseData.message);
        this.UserRightsList =[];
      }
      
    }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.router.navigate(['/']);
    });

  }

  resetAll() {
    $("#UserID").val(0);
    this.UserRightsList = [];
  }

  checkall(id, childid) {
    if (this.UserRightsList != undefined) {
      var c = $("#" + id).prop("checked");
      if (c) {
        for (var i = 0; i < this.UserRightsList.length; i++) {
          $("#" + childid + i).prop("checked", true);
        }
      } else {
        for (var i = 0; i < this.UserRightsList.length; i++) {
          $("#" + childid + i).prop("checked", false);
        }
      }
    }
  }

}
